export enum DataTypeIdValue {
  "Число" = 1,
  "Строка",
  "Дата",
  "Словарный термин",
  "Целое число",
  "Натуральное число",
}
